import request from "./request";

const getProducts = () => request("/bi/prodcuts", null, "GET");
//查看用户权限（两个数组）
const getProductAdvertisers = (data) => request("/bi/getUserAdvertisers", data, "POST");
//分配用户权限
const grantUserPermission = (data) => request("/bi/grantUserPermission", data, "POST");

const queryUserPermission = (data) => request("/bi/queryUserPermission", data, "GET");

//获取部门数据
const getDepartments = (data) => request("/bi/departments", data, "GET");

export default {
  getProducts,
  getProductAdvertisers,
  grantUserPermission,
  queryUserPermission,
  getDepartments
}